export const AppleIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14.9384 5.2052C15.6282 4.34238 16.0964 3.18386 15.9729 2C14.9631 2.05021 13.7308 2.6662 13.0174 3.5297C12.3768 4.26915 11.8098 5.47617 11.9576 6.61041C13.0912 6.70874 14.2237 6.04381 14.9384 5.2052Z"
			fill="#2E3434"
		/>
		<path
			d="M15.9595 6.83176C14.3133 6.73371 12.9136 7.76606 12.1275 7.76606C11.3409 7.76606 10.1371 6.88118 8.83501 6.90503C7.14031 6.92992 5.56781 7.88812 4.70782 9.41211C2.93897 12.4608 4.24102 16.9832 5.96114 19.4662C6.79647 20.6946 7.80318 22.0472 9.12968 21.9986C10.383 21.9494 10.8743 21.1871 12.3977 21.1871C13.9201 21.1871 14.3626 21.9986 15.6893 21.974C17.0651 21.9494 17.9253 20.745 18.7606 19.5154C19.7189 18.115 20.1111 16.7629 20.1358 16.6887C20.1111 16.6641 17.4828 15.6558 17.4584 12.6324C17.4336 10.1009 19.522 8.89672 19.6203 8.82205C18.441 7.07785 16.5983 6.88118 15.9595 6.83176Z"
			fill="#2E3434"
		/>
	</svg>
);
